import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import axiosInstance from '../../utils/axios';

export const getChargerProviders = createAsyncThunk('get/getChargerProviders', async () => {
  const response = await axiosInstance.get('/charger-provider/');
  return response.data;
});

export const list_billing_frequency = createAsyncThunk('get/list_billing_frequency', async ({ rejectWithValue }) => {
  try {
    const response = await axios.post('/charger-provider/list_billing_frequency/');
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addChargerProvider = createAsyncThunk('add/addChargerProvider', async (provider, { dispatch, rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('/charger-provider/', provider);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const providerAprovePictures = createAsyncThunk('post/providerAprovePictures', async (ids, { dispatch, rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('/charger-pictures/approve/', ids);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateProviderPayment = createAsyncThunk(
  'add/updateProviderPayment',
  async ({ provider, data }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/charger-provider/${provider}/payment/`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateProvider = createAsyncThunk(
  'update/updateProvider',
  async ({ idProvider, provider }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/charger-provider/${idProvider}/`, provider);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteProvider = createAsyncThunk('delete/deleteProvider', async (idProvider, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/charger-provider/${idProvider}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getProvider = createAsyncThunk('get/getProvider', async (idProvider, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/charger-provider/${idProvider}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteManyProviders = createAsyncThunk(
  'deleteMany/deleteManyProviders',
  async (providerIDs, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete('/charger-provider/delete_many/', { data: { arrId: providerIDs } });
      dispatch(getChargerProviders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const providerAdapter = createEntityAdapter({});

const providerSlice = createSlice({
  name: 'provider',
  initialState: providerAdapter.getInitialState({
    providers: [],
    billing_frequencys: [],
    provider: null,
    loading: false,
    isLoading: false,
    isSubmitting: false,
  }),

  reducers: {
    setSearchText: (state, action) => {
      state.setSearchText = action.payload;
    },
    setSelectedProviders: (state, action) => {
      state.selectedProviders = action.payload;
    }
  },

  extraReducers: {
    [addChargerProvider.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addChargerProvider.fulfilled]: (state) => {
      providerAdapter.addOne, (state.isSubmitting = false);
    },
    [addChargerProvider.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------------
    [getChargerProviders.pending]: (state) => {
      state.loading = true;
    },
    [getChargerProviders.fulfilled]: (state, action) => {
      state.providers = action.payload.data;
      state.loading = false;
    },
    [getChargerProviders.rejected]: (state) => {
      state.loading = false;
    },
    // -------------------------------------------------
    [updateProviderPayment.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateProviderPayment.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateProviderPayment.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------------
    [getProvider.pending]: (state) => {
      state.loading = true;
    },
    [getProvider.fulfilled]: (state, action) => {
      state.provider = action.payload.data;
      state.loading = false;
    },
    [getProvider.rejected]: (state) => {
      state.isLoading = false;
    },
    // -------------------------------------------------
    [updateProvider.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateProvider.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateProvider.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------------
    [deleteProvider.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteProvider.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteProvider.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------------
    [deleteManyProviders.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyProviders.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyProviders.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------------
    [list_billing_frequency.pending]: (state) => {
      state.isLoading = true;
    },
    [list_billing_frequency.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.billing_frequencys = data;
      state.isLoading = false;
    },
    [list_billing_frequency.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { setSearchText } = providerSlice.actions;

export default providerSlice.reducer;
